export default [
  {
    path: '/dashboard/admin',
    name: 'dashboard-admin',
    component: () => import('@/views/dashboard/admin/Admin.vue'),
    meta: {
      resource: 'admin_dashboard',
      action: 'read'
    },
  },
  {
    path: '/dashboard/revenue',
    name: 'dashboard-revenue',
    component: () => import('@/views/dashboard/revenue/Revenue.vue'),
    meta: {
      resource: 'revenue_dashboard',
      action: 'read',
      pageTitle: 'Revenue',
    },
  },
  {
    path: '/dashboard/main',
    name: 'dashboard-main',
    component: () => import('@/views/dashboard/main/Recruiter.vue'),
    meta: {
      resource: 'main_dashboard',
      action: 'read',
      pageTitle: 'Main Dashboard',
    },
  },
  {
    path: '/dashboard/performance',
    name: 'dashboard-performance',
    component: () => import('@/views/dashboard/performance-dashboard/PerformanceDashboard.vue'),
    meta: {
      resource: 'performance_dashboard',
      action: 'read',
      pageTitle: 'Performance',
    },
  },
  {
    path: '/dashboard/power-bi/',
    name: 'dashboard-power-bi',
    component: () => import('@/views/dashboard/power-bi/PowerBI.vue'),
    meta: {
      resource: 'powerbi',
      action: 'read',
      pageTitle: 'Power BI Dashboards',
    },
  },
  {
    path: '/dashboard/kpmg-rpo',
    name: 'dashboard-kpmg-rpo',
    component: () => import('@/views/dashboard/KPMGRPODashboard.vue'),
    meta: {
      resource: 'kpmg_rpo_dashboard',
      action: 'read',
      pageTitle: 'KPMG RPO Dashboard',
    },
  },
  {
    path: '/dashboard/attendance',
    name: 'dashboard-attendance',
    component: () => import('@/views/dashboard/attendance/AttendanceDashboard.vue'),
    meta: {
      resource: 'attendance',
      action: 'read',
      // pageTitle: 'Attendance Dashboard',
    },
  },
  {
    path: '/dashboard/org-chart',
    name: 'dashboard-org-chart',
    component: () => import('@/views/dashboard/org-chart/OrgChart.vue'),
    meta: {
      resource: 'org_chart',
      action: 'read',
      pageTitle: 'Organization Chart',
    },
  },
  {
    path: '/dashboard/client',
    name: 'dashboard-client-selection',
    component: () => import('@/views/dashboard/ClientSelection.vue'),
    meta: {
      clientDashboardAccess: true,
      pageTitle: 'Select Client Dashboard',
    },
  },
  {
    path: '/dashboard/client/:clientName',
    name: 'dashboard-client',
    component: () => import('@/views/dashboard/UnifiedClientDashboard.vue'),
    meta: {
      clientDashboardAccess: true,
      pageTitle: 'Client Dashboard',
      // Teal uppercase navbar title (was the in-page eyebrow above the client name)
      pageTitleEyebrow: true,
    },
    props: true, // Pass route params as props
  },
  {
    path: '/dashboard/reliance',
    name: 'dashboard-reliance',
    component: () => import('@/views/dashboard/reliance/RelianceDashboard.vue'),
    meta: {
      resource: 'reliance_dashboard',
      action: 'read',
    },
  },
  // {
  //   path: '/dashboard/analytics/recruiter-scorecard',
  //   name: 'dashboard-analytics-recruiter-scorecard',
  //   component: () => import('@/views/dashboard/analytics/scorecard/RecruiterScorcard.vue'),
  //   meta: {
  //     resource: 'recruiter_scorecard_dashboard',
  //     action: 'read',
  //     pageTitle: 'Recruiter Scorecard Dashboard',
  //   },
  // },
  // {
  //   path: '/dashboard/analytics/target-config',
  //   name: 'dashboard-analytics-target-config',
  //   component: () => import('@/views/dashboard/analytics/scorecard/TargetsConfig.vue'),
  //   meta: { 
  //     resource: 'targets_config_dashboard',
  //     action: 'read',
  //     pageTitle: 'Targets Config Dashboard',
  //   },
  // },
  // {
  //   path: '/dashboard/analytics/funnel-leakage',
  //   name: 'dashboard-analytics-funnel-leakage',
  //   component: () => import('@/views/dashboard/analytics/FunnelLeakage.vue'),
  //   meta: {
  //     resource: 'funnel_leakage_dashboard',
  //     action: 'read',
  //     pageTitle: 'Funnel Leakage Dashboard',
  //   },
  // },
  // {
  //   path: '/dashboard/analytics/recruitment-effectiveness',
  //   name: 'dashboard-analytics-recruitment-effectiveness',
  //   component: () => import('@/views/dashboard/analytics/RecruitmentEffectiveness.vue'),
  //   meta: {
  //     resource: 'recruitment_effectiveness_dashboard',
  //     action: 'read',
  //     pageTitle: 'Recruitment Effectiveness Dashboard',
  //   },
  // },
  // {
  //   path: '/dashboard/analytics/job-health',
  //   name: 'dashboard-analytics-job-health',
  //   component: () => import('@/views/dashboard/analytics/JobHealth.vue'),
  //   meta: {
  //     resource: 'job_health_dashboard',
  //     action: 'read',
  //     pageTitle: 'Job Health Dashboard',
  //   },
  // },
  // {
  //   path: '/dashboard/analytics/client-quality',
  //   name: 'dashboard-analytics-client-quality',
  //   component: () => import('@/views/dashboard/analytics/ClientQuality.vue'),
  //   meta: {
  //     resource: 'client_quality_dashboard',
  //     action: 'read',
  //     pageTitle: 'Client Quality Dashboard',
  //   },
  // },

]
